import _ from 'lodash';

export const objectToArray = (obj) => {
  const res = [];
  _.forEach(obj, (ele, itemKey) => {
    res.push({
      key: itemKey,
      value: ele,
    });
  });

  return res;
};

export const arrayToObject = (array) => {
  if (!_.isArray(array)) return array;

  const res = {};

  array.forEach((e) => {
    if (e.key != '') {
      res[e.key] = e.value;
    }
  });

  return res;
};

export const stringToList = (str) => _.split(str, ',');

export const listToStr = (array) => _.join(array, ',');
